/**
 * PriorityLowIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const PriorityLowIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m12 10.85 7.425-5.875q.5-.35 1.037-.087.538.262.538.887 0 .25-.113.475a.85.85 0 0 1-.312.35L12 13.3 3.425 6.6a.85.85 0 0 1-.312-.35A1.05 1.05 0 0 1 3 5.775q0-.6.538-.875.537-.275 1.037.075zm0 5.95 7.425-5.875q.5-.35 1.037-.088.538.263.538.888 0 .25-.113.475a.85.85 0 0 1-.312.35L12 19.25l-8.575-6.7a.85.85 0 0 1-.312-.35A1.05 1.05 0 0 1 3 11.725q0-.6.538-.875.537-.274 1.037.075z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const PriorityLowIcon = makeIcon('PriorityLowIcon', PriorityLowIconSvg)
